export default __webpack_public_path__ + "static/media/bean bag.45a92d38.jpg";